import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useTranslation } from "react-i18next";
import { useGetBoxtypeValues } from "@/services/Orders";
import { BoxType } from "@/types";

type keyOptions = Extract<keyof BoxType, string>;

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions;
}

/**
 * SelectCondition component renders a Select dropdown for conditions.
 * - Uses translation for option labels.
 * @param {SelectPropsExtended} props - Props for the SelectCondition component.
 * @param {keyOptions} props.valueKey - Key to use for option values.
 * @param {keyOptions} props.labelKey - Key to use for option labels.
 */
const SelectProductBoxType: React.FC<SelectPropsExtended> = ({
  valueKey,
  labelKey,
  ...restProps
}: SelectPropsExtended) => {
  const { data: boxTypes, isLoading } = useGetBoxtypeValues();
  const { t } = useTranslation();

  const sourceData = boxTypes || [];
  const options = transformDataToSelectOption(sourceData, valueKey || "id", labelKey || "description", t);
  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectProductBoxType;
